import { createContext } from 'react';
import { rbacActions } from '../config/rbac/actions.ts';


type VerifiedPermissionsContextType = {
    authorizing: boolean;
    allowedActions: rbacActions[],
}

export const VerifiedPermissionsContext = createContext<VerifiedPermissionsContextType>({
                                                                                            authorizing: false,
                                                                                            allowedActions: [],
                                                                                        });

